import { Box } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { WebchatWidgetPopup } from './WebchatWidgetPopup';

interface WebchatWidgetProps {}

export const WebchatWidget: FunctionComponent<WebchatWidgetProps> = (props) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <WebchatWidgetPopup />
    </Box>
  );
};
